module.exports = __webpack_public_path__ + "img/btn_stomach_off.d48269fd.svg";